import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError';
import { Toast } from '../../../../../../Notification';

const deleteTourIndicator = async ({ state, userId, removeTourIndicator, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { tourIndicatorId, tourStartTime } = itemDetails;
  const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Indicator Deleted', description: `For ${resource.name} on ${day}`};
  try {
    await removeTourIndicator(tourIndicatorId);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeTourIndicator',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Indicator Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default deleteTourIndicator;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/tour/indicator/deleteTourIndicator.js